<style></style>
<template>
  <div class="creatMessage-box">
    <div class="shade-box">
      <div class="shade-content shade-width">
        <p class="dialog-title-bg">{{title}}模板
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetMessageForm('creatMessageForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="creatForm" :rules="$rules" ref="creatMessageForm" label-width="120px" class="demo-ruleForm">
            <!-- <el-form-item label="通道编号" prop="platformNum">
              <el-select v-model="creatForm.platformNum" placeholder="请选择" ref="platformNum">
                <el-option label="华为" value='huawei'></el-option>
                <el-option label="腾讯" value='tencent'></el-option>
              </el-select>
             </el-form-item> -->
            <el-form-item label="模板类型" prop="mouldTypeId">
              <el-select v-model="creatForm.mouldTypeId" placeholder="请选择">
                <el-option label="营销短信" value='1'></el-option>
                <el-option label="通知短信" value='2'></el-option>
                <el-option label="验证码" value='3'></el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="模板名称" prop="mouldName">
              <el-input v-model="creatForm.mouldName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="模板内容" prop="mouldContent">
              <el-input v-model="creatForm.mouldContent" type="textarea" @input="computeRematn" resize="none" maxlength="450" :autosize="{ minRows: 5, maxRows: 10}" placeholder="模板示例：{1}为您的登录验证码，请于{2}分钟内填写。如非本人操作，请忽略本短信。（其中{数字}为可自定义的内容，须从1开始连续编号，如{1}、{2}等"></el-input>
            </el-form-item>
            <el-form-item>
              <p class="colorBBB">已输入 <span class="text-red">{{remain}}</span> 个字，最多可输入450个字</p>
              <p class="colorBBB">当前模板预计发送条数约为 <span class="text-red"> {{num}} </span> 条短信</p>
              <p class="text-red">（实际发送时，签名和模板变量会影响计费条数，请特别关注）</p>
              <p> 1.长度不超过450字。单条短信超过70字后，按67字/条分多条计费;</p>
              <p>2.营销类短信，请在短信内容后面增加“回T退订”;</p>
              <p>3.短信模板内容不能含有【】符号;</p>
              <p>4.不能发送房产、移民、贷款、政治、色情暴力等违法短信;</p>
              <p> 模板示例：{1}为您的登录验证码，请于{2}分钟内填写。如非本人操作，请忽略本短信。 （其中{数字}为可自定义的内容，须从1开始连续编号，如{1}、{2}等。）</p>
            </el-form-item>
            <el-form-item label="申请说明" prop="mouldReason">
              <el-input v-model="creatForm.mouldReason" placeholder="请描述模板内容的发送场景和发送对象"></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('creatMessageForm')" :disabled="disabled">立即{{title}}</el-button>
              <el-button @click="resetMessageForm('creatMessageForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  props: {
    data:{
      type: Object
    }
  },
  name: "creatMessage",
  data(){
    return{
      title: '创建',
      disabled: false,
      remain: 0,//剩余输入字数
      num: 0,
      creatForm: {
        mouldTypeId: '',//模板类型
        mouldName: '',
        mouldContent: '',
        mouldReason: ''//模板申请原因
      },
    };
  },
  created(){
    if(this.data){
      this.creatForm = JSON.parse(JSON.stringify(this.data)) ;
      this.creatForm.mouldTypeId = ''+ this.data.mouldTypeId;
      this.title = "修改";
      this.computeRematn(this.data.mouldContent)
    }
  },
  methods: {
    computeRematn(v){
      this.remain = v.length;
      if(v.length == 0){
        this.num = 0;
      }else if(v.length > 0 & v.length < 71){
        this.num = 1;
      }else{
        this.num = Math.ceil(v.length / 67);
      }
    },
    submitForm(formName){//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          if(this.data){
            this.reviseUp()
          }else{
            this.addUp()
          }
        } else {
          return false;
        }
      });
    },
    addUp(){
      let data = {
        "mouldType": this.creatForm.mouldTypeId,//模板类型
        "mouldName": this.creatForm.mouldName,//模板名称
        "mouldContent": this.creatForm.mouldContent,//模板内容
        "mouldReason": this.creatForm.mouldReason,//模板申请原因
      }
      api.addMessage({data:data}).then(res =>{
        this.disabled = false;
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.$emit('closeComponent',true)
        }
      })
    },
    reviseUp(){
      let data = {
        "mouldSign": this.creatForm.mouldSign,
        "mouldType": this.creatForm.mouldTypeId,//模板类型
        "mouldName": this.creatForm.mouldName,//模板名称
        "mouldContent": this.creatForm.mouldContent,//模板内容
        "mouldReason": this.creatForm.mouldReason,//模板申请原因
      }
      api.reviseMessage({data:data}).then(res =>{
        this.disabled = false
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.$emit('closeComponent',true)
        }
      })
    },
    resetMessageForm(formName){//取消
      // this.$refs[formName].resetFields();
      this.$emit('closeComponent',false)
    }
  },
  components: {

  }
}
</script>





// WEBPACK FOOTER //
// src/components/message/creatMessage.vue